import { Checkbox, FormControlLabel, Stack } from '@mui/material';
import { actionStatusOptions } from 'actions/list/useActionFilters';
import { FC } from 'react';

type ActionStatusCheckListProps = Readonly<{
	value: readonly string[];
	onChange(newStatuses: readonly string[]): void;
}>;

export const ActionStatusCheckList: FC<ActionStatusCheckListProps> = ({ value, onChange }) => {
	const statuses = actionStatusOptions;
	const selectedStatuses = value.filter((id) => statuses.some((o) => o === id));

	return (
		<Stack direction={'column'}>
			{/* eslint-disable-next-line @typescript-eslint/no-unnecessary-condition */}
			{statuses.length > 0 &&
				statuses.map((tag) => (
					<FormControlLabel
						label={tag[0].toUpperCase() + tag.slice(1)}
						control={
							<Checkbox
								id={tag}
								name={tag}
								value={value}
								onChange={() =>
									selectedStatuses.includes(tag)
										? onChange(selectedStatuses.filter((statusId) => statusId !== tag))
										: onChange(selectedStatuses.concat(tag))
								}
								checked={selectedStatuses.includes(tag)}
							/>
						}
					/>
				))}
		</Stack>
	);
};
